import request from '@/utils/request'
// 评价接口
export function saveOrdEvaluate(data) {
  return request({
    url: `/ord/evaluate/saveOrdEvaluate`,
    method: 'post',
    data
  })
}
// 评价接口
export function selectOrdEvaluateDetail(data) {
  return request({
    url: `/ord/evaluate/selectOrdEvaluateDetail `,
    method: 'post',
    data
  })
}